import "@fontsource/ubuntu";
import { wrapPageElement as wrap } from "./src/wrapper";
export const wrapPageElement = wrap;
